// extracted by mini-css-extract-plugin
export default {"container":"Testimonial_container__DP7t-","card":"Testimonial_card__PqRcB","title":"Testimonial_title__g0H+-"};